import { oz } from '@weft/utils';
import { withNullAsOptional } from '../../utils/literal-transforms';
import { AggregationMethodSchema } from './aggregation-method/aggregation-method-schema';
import { FilterSchema } from './filter-schema';

export const NewMeterSchema = oz.object({
  eventName: oz.string().nonempty(),
  name: oz.string().nonempty(),
  description: oz.string().optional(),
  filter: withNullAsOptional(FilterSchema),
  aggregationMethod: AggregationMethodSchema,
});

export type NewMeter = oz.infer<typeof NewMeterSchema>;
